import React, { useEffect, useState } from "react";
import PrivateApi from "../../../services/PrivateApiService";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import HvAnlageCard from '../../anlage/HvAnlageCard';
import DataTable from "react-data-table-component";

/**
 * 
 * @param {state} props list of last backend collectings
 * @param {setState} props setter will be set by data collection from backend to avoid multi collect of same data
 * @param {about} props string ticket about
 * @param {setSelectedAnlage} props object setter
 * @param {selectedBuilding} props object of selected building
 * @param {setStage} props string setter
 * @param {error} props string setter for api errors
 * @param {customer} props bool if customer preload data
 */
const AnlageTicketStage = (props) => {

    const API = new PrivateApi();
    const [anlagenLoading, setAnlagenLoading] = useState(false);
    const [anlagen, setAnlagen] = useState(props.state);
    const [filteredAnlagen, setFilteredAnlagen] = useState(props.state);
    const [selectedAnlage, setSelectedAnlage] = useState(null);
    const anlagenTableColumns = [
        { name: "ENERGO", selector: row => row.x_studio_field_mWMGR, sortable: true },
        { name: "Top", selector: row => row.x_studio_field_6T9W2 === "False" ? "-" : row.x_studio_field_6T9W2, sortable: true },
        { name: "Anlageverwendung", selector: row => row.x_anlagenverwendung === "False" ? "unbekannt" : row.x_anlagenverwendung, sortable: true },
        { name: "Zählernummer", selector: row => row.x_zaehlernummer_02 !== ""? `${row.x_zaehlernummer_01} - ${row.x_zaehlernummer_02}`: row.x_zaehlernummer_01, sortable: true}
    ]

    const paginationOptions = {
        rowsPerPageText: 'Zeilen pro Seite',
        rangeSeparatorText: 'von',
        selectAllRowsItemText: 'Alle'
    }


    useEffect(() => {
        setSelectedAnlage(null);

        if (props.customer === undefined || props.customer === false) {
            if (anlagen === undefined || anlagen.length === 0 || anlagen[0].x_studio_field_Xhbek[0] !== props.selectedBuilding.id) {
                setAnlagenLoading(true);
                API.get_AnlagenBuilding(props.selectedBuilding.id)
                    .then(res => {
                        let data = res.data;
                        setAnlagen(data);
                        setFilteredAnlagen(data);
                        props.setState(data);
                        setAnlagenLoading(false);
                    })
                    .catch(err => {
                        if (err.response.data.detail !== undefined) {
                            props.error(err.response.data.detail)
                        } else {
                            props.error("Unbekanntes Fehler");
                        }
                        setAnlagenLoading(false);
                    })
            }
        }
        if (props.customer !== undefined && props.customer === true) {
            setAnlagenLoading(true);
            API.get_Anlagen()
                .then(res => {
                    let data = res.data;
                    setAnlagen(res.data);
                    setFilteredAnlagen(res.data);
                    setAnlagenLoading(false);
                })
                .catch(err => {
                    if (err.response.data.detail !== undefined) {
                        props.error(err.response.data.detail);
                    } else {
                        props.error("Unbekanntes Fehler.");
                    }
                    setAnlagenLoading(false);
                    props.setStage("error");
                })
        }
    }, [])



    // * handlers 
    const conditionalRowStyles = [
        {
            when: row => selectedAnlage && selectedAnlage === row,
            style: {
                background: '#a2c13f',
                userSelect: "none",
            }
        }
    ]


    const selectTableAnlagenHandler = (row) => {
        if (selectedAnlage === row) setSelectedAnlage(null);
        else setSelectedAnlage(row);
    }

    // next btn handler 
    const nextBtnHandler = () => {
        // props.customer? props.setStage('body'): props.setStage('energielieferant')}
        if (props.customer && props.selectedInvoiceType !== "Energielieferant") {
            props.setStage("body");
        } else {
            props.setStage("energielieferant");
        }
    }

    // back btn handler 
    const backBtnHandler = () => {
        // props.customer? props.setStage("default"): props.setStage("buildings")
        if (props.customer && props.about === "Rechnung (ENERGO, Lieferantenrechnung)") {
            return props.setStage("Rechnung (ENERGO, Lieferantenrechnung)");
        }
        if (props.customer && props.about === "Anlagen") {
            return props.setStage("default");
        }
        props.setStage("buildings");
    }


    return (
        <>
            {anlagenLoading ?
                <Row className="mt-5 text-center">
                    {props.selectedBuilding !== undefined ?
                        <>
                            <p>Anlagen von Gebäude <span className="text-energo">{props.selectedBuilding.name}</span> werden gesammelt...</p>
                            
                        </>
                        :
                        <p>Ihre Anlagen werden gesammelt...</p>
                    }
                    <Col xs="12">
                        <Spinner className="text-energo" animation="grow" /> &nbsp;
                        <Spinner className="text-energo" animation="grow" /> &nbsp;
                        <Spinner className="text-energo" animation="grow" /> &nbsp;
                    </Col>
                </Row>
                :
                <>
                    <h5>Um welche Anlage handelt es sich?</h5>
                    <p hidden={props.selectedBuilding === undefined}><small>Anlagen in: </small>{props.selectedBuilding !== undefined? props.selectedBuilding.street:null}</p>
                    <p>(Für Details bitte Anlage wählen)</p>
                    <Row className="mt-5">
                        <DataTable 
                            onRowClicked={row => selectTableAnlagenHandler(row)} 
                            data={filteredAnlagen} 
                            columns={anlagenTableColumns} 
                            conditionalRowStyles={conditionalRowStyles}
                            paginationComponentOptions={paginationOptions}
                            noDataComponent="Es sind keine Anlagen verfügbar"
                            dense pagination pointerOnHover 
                            />
                    </Row>
                            {selectedAnlage !== null ?
                                <Row className="mt-5 justify-content-center">
                                    <p>Ausgewählte Anlage:</p>
                                    <Col xl="12">
                                        <HvAnlageCard anlage={selectedAnlage} noElvs />
                                    </Col>
                                </Row>
                                : null}
                    <Row className="mt-5">
                        <Col xs="12" className="text-end">
                            <Button onClick={() => backBtnHandler()} variant="warning" style={{ marginRight: "5px" }}>Zurück</Button>
                            <Button onClick={() => {props.setSelectedAnlage(selectedAnlage); nextBtnHandler();}} className="btn-energo" disabled={selectedAnlage === null}>Weiter</Button>
                        </Col>
                    </Row>
                </>
            }
        </>
    )
}

export default AnlageTicketStage;